export default function replaceHistoryStateToSamePageWithoutQueryParams(
  queryParamsToDelete: string[],
) {
  if (queryParamsToDelete.length === 0) {
    return;
  }

  const currentURL = new URL(window.location.href);
  currentURL.search = "";

  const currentQueryParams = new URLSearchParams(window.location.search);

  const existingQueryParamsToDelete = queryParamsToDelete.filter((qp) =>
    currentQueryParams.has(qp),
  );
  if (existingQueryParamsToDelete.length === 0) {
    return;
  }

  existingQueryParamsToDelete.forEach((qp) => {
    currentQueryParams.delete(qp);
  });

  const newQueryParams =
    currentQueryParams.toString() === ""
      ? ""
      : `?${currentQueryParams.toString()}`;

  window.history.replaceState(
    null,
    "",
    `${currentURL.toString()}${newQueryParams}`,
  );
}
